@if (form) {
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <rask-selector class="col-2"
                label="Anskaffningsform"
                [(ngModel)]="skapaArbetsorderModel.anskaffningsForm"
                [rule]="validationContext.current.anskaffningsForm"
                formControlName="anskaffningsForm"
                [values]="valbaraAnskaffningsformer"
                (change)="anskaffningsformChanged()">
            </rask-selector>
            <rask-selector class="col-2"
                label="Transportslag"
                [(ngModel)]="skapaArbetsorderModel.transportslag"
                formControlName="transportslag"
                [values]="valbaraTransportslag"
                [canDelete]="false"
                (change)="transportslagChanged($event)">
            </rask-selector>
            <rask-input class="col-2"
                label="Namn"
                formControlName="namn"
                [rule]="validationContext.current.arbetsorderNamn"
                [maxlength]="arbetsorderNamnMaxLength"
                [(ngModel)]="skapaArbetsorderModel.namn"></rask-input>
            <rask-selector class="col-3"
                label="Hämtplats i Sverige"
                [(ngModel)]="skapaArbetsorderModel.hamtplatsId"
                formControlName="hamtplatsId"
                [values]="getMottagningsplatserForTyp()"
                [formatter]="mottagningsplatsFormatter"
                [rule]="validationContext.current.hamtplatsId"
                [viewFormatter]="mottagningsplatsViewFormatter"
                (change)="mottagningsplatsChanged()">
            </rask-selector>
            <rask-selector class="col-2"
                label="Lagerplats"
                [(ngModel)]="skapaArbetsorderModel.lagerplatsId"
                formControlName="lagerplatsId"
                [values]="getLagerplatser()"
                [formatter]="lagerplatserFormatter"
                [rule]="validationContext.current.lagerplats"
                [viewFormatter]="lagerplatserViewFormatter">
            </rask-selector>
        </div>
        @if (skapaArbetsorderModel.transportslag === 'Sjötransport') {
        <div class="row">
            <rask-radiobutton-group
                class="col-2"
                label="Avgångsmätning"
                [buttons]="activetypes"
                formControlName="avgangsmatning"
                [rule]="validationContext.current.avgangsmatning"
                [(ngModel)]="skapaArbetsorderModel.avgangsmatning">
            </rask-radiobutton-group>
            @if (skapaArbetsorderModel.avgangsmatning) {
            <rask-selector
                class="col-3"
                label="Avgångshamn"
                [(ngModel)]="skapaArbetsorderModel.mottagningsplatsAvgangshamnId"
                formControlName="mottagningsplatsAvgangshamnId"
                [values]="getMottagningsplatserForTyp()"
                [formatter]="mottagningsplatsFormatter"
                [viewFormatter]="mottagningsplatsViewFormatter">
            </rask-selector>
            }
            @if (skapaArbetsorderModel.avgangsmatning) {
            <rask-selector
                class="col-2"
                label="Lagerplats hamn"
                [(ngModel)]="skapaArbetsorderModel.avgangshamnId"
                formControlName="avgangshamnId"
                [values]="getLagerplatserForAvgangshamn()"
                [formatter]="lagerplatserFormatter"
                [rule]="validationContext.current.avgangshamn"
                [viewFormatter]="lagerplatserViewFormatter">
            </rask-selector>
            }
            @if (skapaArbetsorderModel.avgangsmatning) {
            <rask-selector
                class="col-3"
                label="Kund"
                formControlName="kundId"
                [(ngModel)]="skapaArbetsorderModel.kundId"
                [formatter]="kundFormatter"
                [reverseLookup]="true"
                [minCharacters]="3"
                [placeholder]="'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate"
                [search]="searchForKunder"
                [rule]="validationContext.current.kund"
                [viewFormatter]="kundViewFormatter">
            </rask-selector>
            }
        </div>
        }

        @if (skapaArbetsorderModel.avgangsmatning) {
        <div class="row">
            <rask-checkbox class="col-4" [text]="'Med biltransport'" [(ngModel)]="skapaArbetsorderModel.medBil"
                formControlName="medBil"> </rask-checkbox>
        </div>
        }
        <div class="row">
            <rask-datepicker class="col-2"
                formControlName="startDatum"
                label="Startdatum"
                [onlyMonths]="false"
                [(ngModel)]="skapaArbetsorderModel.startDatum">
            </rask-datepicker>
            <rask-datepicker class="col-2"
                formControlName="slutDatum"
                label="Slutdatum"
                [onlyMonths]="false"
                [(ngModel)]="skapaArbetsorderModel.slutDatum">
            </rask-datepicker>
            <rask-selector class="col-3"
                label="Transportföretag"
                [(ngModel)]="skapaArbetsorderModel.transportforetagId"
                formControlName="transportforetagId"
                [values]="transportforetag"
                [formatter]="transportforetagFormatter"
                [viewFormatter]="transportforetagViewFormatter">
            </rask-selector>
            @if (skapaArbetsorderModel.anskaffningsForm === 'Import' && ckLeverantorer) {
            <rask-selector
                class="col-2"
                label="Leverantör"
                [(ngModel)]="skapaArbetsorderModel.ckleverantorId"
                formControlName="ckleverantorId"
                [values]="ckLeverantorer"
                [formatter]="ckleverantorFormatter"
                [rule]="validationContext.current.leverantor"
                [viewFormatter]="ckleverantorViewFormatter">
            </rask-selector>
            }
            @if (skapaArbetsorderModel.transportslag === 'Sjötransport') {
            <rask-input
                class="col-2"
                label="Båt id"
                formControlName="batId"
                [maxlength]="10"
                [rule]="validationContext.current.batId"
                [(ngModel)]="skapaArbetsorderModel.batId">
            </rask-input>
            }
        </div>
    </form>
</div>
}
<div class="modal-footer">
    <rask-button aid="buttonSpara" color="primary" (click)="save()" [disabled]="!canSave()">Spara</rask-button>
    <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
</div>